import { createAction, props } from "@ngrx/store";

export default {
  viewTypeLoaded: createAction("[Dashboard] ViewType loaded successfuly", (viewType: string) => ({ viewType })),
  reset: createAction("[Dashboard] reseted"),
  error: createAction("[Dashboard] error", props<{ error: string }>())
};
